export enum DocumentTypeEnum {
  CC = 'Cédula de Ciudadanía',
  DNI = 'Documento Nacional de Identidad',
  CI = 'CI',
  CURP = 'CURP',
  DPI = 'DPI',
  DUI = 'DUI',
  CIE = 'CIE',
  CIP = 'CIP',
  CIC = 'CIC',
  ID = 'ID',
  PASAPORTE = 'Pasaporte',
  CEDULA_DE_EXTRANJERIA = 'Cédula de Extranjería',
  NIT = 'Número de Identificación Tributaria',
  TI = 'Tarjeta de Identidad',
  OTR = 'Otro',
}
